import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSplit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"split"} maskId="square-filled-radius-0-stroke-1-IconSplit"><path d="M2 4H10V20H2V4Z" fill="currentColor"/><path d="M14 4H22V20H14V4Z" fill="currentColor"/><path d="M11.5 2H12.5V22H11.5V2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSplit;
